<template>
  <div v-show="!noRecords">
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
          <ul v-show='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <span>غرض الاتصال:</span>
          <input disabled value='سداد قسط فلتر' class='form-control' name='notes' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <span>حالة الاتصال:</span>
          <select class="form-control" style="padding: 0px" v-model="record.call_status_id">
            <option v-for="item in callStatus" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <span>الاجراء:</span>
          <select class="form-control" style="padding: 0px" v-model="record.call_action_id">
            <option v-for="item in actions" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
          <span>التأجيل:</span>
          <select class="form-control" style="padding: 0px" v-model="record.delay">
            <option v-for="item in 30" :value="item -1 " v-bind:key="item" >
              {{ item -1 }}
            </option>
          </select>
        </div>
      </div>
      <div class='col-lg-12' style='padding:0px'>
        <div class='col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
          <div class='col-lg-12 col-sm-12' style='padding: 0px 0px 0px 0px;'>
            <span>ملاحظات الاتصال:</span>
            <input  @keyup='mirrorNotes()' class="form-control" v-model="record.callNotes" name='notes' type='text'>
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 10px 0px;'>
            <span>ملاحظات الفنى:</span>
            <input  v-model='record.notes' class='form-control' name='notes' type='text'>
          </div>
          <table width='100%' class='table table-bordered '>
            <thead>
              <tr>
                <th style='padding:2px;text-align: center'>م</th>
                <th style='padding:2px;text-align: center'>الاستحقاق</th>
                <th style='padding:2px;text-align: center'>السداد</th>
                <th style='padding:2px;text-align: center'>المبلغ</th>
                <th style='padding:2px;text-align: center'>المدفوع</th>
                <th style='padding:2px;text-align: center'>الباقى</th>
              </tr>
            </thead>
            <tbody>
              <tr v-on:click="changeAction(record.id)" :class="{highlight :record.action}" class='odd gradeX' v-for='(record) in InstallmentRecords' :key='record.id'>
                <td style='padding:2px;text-align: center'>{{record.id}}</td>
                <td style='padding:2px;text-align: center'>{{record.due_date}}</td>
                <td style='padding:2px;text-align: center'>{{record.payment_date}}</td>
                <td style='padding:2px;text-align: center'>{{record.amount}}</td>
                <td style='padding:2px;text-align: center'>{{record.total_paid}}</td>
                <td style='padding:2px;text-align: center'>{{record.reset}}</td>
              </tr>
            </tbody>
          </table>
          <div class='col-lg-12 col-sm-12' style='padding: 0px 0px 0px 0px;'>
            <label>المدفوع:</label>
            {{record.amount_str}}
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 0px;'>
            <label>أقساط مسددة:</label>
            {{record.caption}}
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 0px;'>
            <label>الباقى:</label>
            {{record.rest_str}}
          </div>
          <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
            <label>رصيد أقساط:</label>
            <input  @keypress="isLocked($event)"  v-model='record.balance' class='form-control' name='amount' type='text'>
          </div>
          <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
            <label>رصيد صيانة:</label>
            <input  @keypress="isLocked($event)"  v-model='record.maintenance_balance' class='form-control' name='amount' type='text'>
          </div>
          <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
            <label>المديونية:</label>
            <input @keypress="isLocked($event)" v-model='record.required' class='form-control' name='amount' type='text'>
          </div>
          <div class="col-lg-4 col-sm-4" style='padding: 0px 0px 0px 10px;'>
            <label>المدفوع:</label>
            <input  @keypress="isNumber($event)" @keyup='fillReceiptItems(true)' v-model='record.paid' class='form-control' name='amount' type='text'>
          </div>
          <div class="col-lg-4 col-sm-4" style='padding: 0px 0px 0px 10px;'>
            <label>الباقى:</label>
            <input  @keypress="isLocked($event)" v-model='record.rest' class='form-control' name='amount' type='text'>
          </div>
          <div class="col-lg-4 col-sm-4" style='padding: 0px 0px 0px 10px;'>
            <label>تاريخ القسط</label>
            <input v-model='receiptDate' class='form-control' name='receiptDate' type='text'>
          </div>
        </div>
        <div class='col-lg-6 col-sm-6' style='padding: 5px 0px 0px 10px;'>
          <div class='col-lg-4 col-md-4 col-sm-4' style='padding: 3px 0px 10px 10px;'>
            <span >النوع:</span>
            <select ref="price_type"  style="padding: 0px" @change="fillReceiptItems()" class="form-control" v-model="itemsPriceType">
              <option v-for="item in price_types" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name}}
              </option>
            </select>
          </div>
          <div class='col-lg-8 col-md-8 col-sm-8' style='padding: 3px 0px 10px 0px;'>
            <span >أصناف خارج العرض:</span>
            <input ref="maintenanceItems" v-on:keypress="offer_foucs($event)" v-model='offer' class='form-control' type='text'>
          </div>
          <div class="row" style="padding: 15px 18px 0px 18px;">
            <table width='100%' class='table table-striped table-bordered table-hover' >
              <thead>
                <tr>
                  <th style='padding:2px;text-align: center'>البيــــان</th>
                  <th style='padding:2px;text-align: center'>السعر</th>
                </tr>
              </thead>
              <tbody>
                <tr class='odd gradeX' v-for='(record) in receiptItems' :key='record.id'>
                  <td style='padding:2px;text-align: center'>{{record.label}}</td>
                  <td style='padding:2px;text-align: center'>{{record.price}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <table width='100%' class='table table-bordered '>
            <thead>
              <tr>
                <th style='padding:2px;text-align: center'>م</th>
                <th style='padding:2px;text-align: center'>الصنف</th>
                <th style='padding:2px;text-align: center'>التاريخ الافتراضى</th>
                <th style='padding:2px;text-align: center'>تاريخ التغيير</th>
              </tr>
            </thead>
            <tbody>
              <tr v-on:click="changeMaintenanAction(record.id)" :class="{highlight :record.action}" class='odd gradeX' v-for='(record) in maintenancRecords' :key='record.id'>
                <td style='padding:2px;text-align: center'>{{record.id}}</td>
                <td style='padding:2px;text-align: center'>{{record.item}}</td>
                <td style='padding:2px;text-align: center'>{{record.default_date}}</td>
                <td style='padding:2px;text-align: center'>{{record.change_date}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if='!successShow' class='col-lg-12 col-sm-12' style='text-align:center;padding:10px'>
        <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
        <button  @click='saveData()'  style="width: 100px" type='button' class='btn btn-success'>إصدار</button>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #00E40E;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import tafqeet from '@/./assets/Tafqeet.js'
export default {
  components: {
    tbDate
  },
  name: 'CreateDailyReceipts',
  data () {
    return {
      receiptItems: [],
      price_types: [
        {id: 1, name: 'كاش'},
        {id: 4, name: 'ضمان'},
        {id: 5, name: 'هدية'},
        {id: 0, name: 'عرض سابق'}
      ],
      itemsPriceType: 4,
      offer: '',
      items: '',
      InstallmentRecords: '',
      maintenancRecords: '',
      actions: {},
      callStatus: {},
      today: true,
      receiptDate: '',
      title: '',
      DateTitle: 'التاريخ',
      validationErrors: '',
      records: {},
      record: {},
      offers: {},
      offer_id: 0,
      OfferRecords: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isContractOffersLoading: false,
      isOfferRecordsLoading: false,
      branches: {},
      type: 0,
      contract_offer_id: 0,
      uid: '',
      dateTo: '',
      date: '',
      noRecords: false,
      isInLimit: false
    }
  },
  props: {
    callMethod: ''
  },
  methods: {
    tabSelected (id, fromDate, toDate, type, offerID, isInLimit, offers, items) {
      this.receiptItems = []
      this.itemsPriceType = 4
      this.offer = ''
      this.validationErrors = ''
      this.items = items
      this.offers = offers
      this.InstallmentRecords = null
      this.maintenancRecords = null
      this.record = null
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      this.validationErrors = ''
      this.GetCallData()
      this.dateFrom = fromDate
      this.dateTo = toDate
      this.uid = id
      this.offer_id = offerID
      this.contract_offer_id = offerID
      this.isInLimit = isInLimit
      // -----------------------------------------------------
      this.record = {}
      this.type = type
      this.getData(id, fromDate, toDate, type)
      this.OfferRecords = ''
    },
    // ========================================================
    GetCallData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-customer-call-logs', {
        token: localStorage.getItem('token'),
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.isLoadingData = false
          this.actions = res.data.Actions
          this.callStatus = res.data.Status
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ========================================================
    addDays () {
      /*
      var date = new Date(this.record.default_date)
      date.setTime(date.getTime() + (this.record.call_delay * 24 * 60 * 60 * 1000))
      var dd = date.getDate()
      var mm = date.getMonth() + 1
      var y = date.getFullYear()
      var newDate = y + '-' + mm + '-' + dd
      this.date = newDate
      */
    },
    // ======================================================
    offer_foucs (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        this.fillReceiptItems()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45 && charCode !== 42) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ========================================================
    fillReceiptItems (isFromPaid) {
      var totalPrice = 0
      this.receiptItems = []
      // -----------------------------------------------------------
      if (this.record.balance > 0) {
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = 'رصيد اقساط'
        this.receiptItems[this.receiptItems.length - 1].rec_id = 0
        this.receiptItems[this.receiptItems.length - 1].type = 7
        this.receiptItems[this.receiptItems.length - 1].price = this.record.balance
        this.receiptItems[this.receiptItems.length - 1].priceType = ''
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
        totalPrice = Number(this.record.balance)
      }
      // -----------------------------------------------------------
      if (this.record.maintenance_balance > 0) {
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = 'رصيد صيانة'
        this.receiptItems[this.receiptItems.length - 1].rec_id = 0
        this.receiptItems[this.receiptItems.length - 1].type = 8
        this.receiptItems[this.receiptItems.length - 1].price = this.record.maintenance_balance
        this.receiptItems[this.receiptItems.length - 1].priceType = ''
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
        totalPrice = Number(totalPrice) + Number(this.record.maintenance_balance)
      }
      // ================================================
      var price = 0
      var arr = this.offer.split('-')
      var itemsPriceTypeStr = ''
      this.OfferRecords = []
      if (Array.isArray(arr) && arr[0].length) {
        for (let i = 0; i < arr.length; i++) {
          if (Array.isArray(arr) && arr[0].length) {
            let y = this.items.findIndex(x => x.item_id === parseInt(arr[i]))
            if (y > -1) {
              if (parseInt(this.itemsPriceType) === 1) {
                price = this.items[y].price
                itemsPriceTypeStr = ''
              } else if (parseInt(this.itemsPriceType) === 4) {
                price = this.items[y].warranty_price
                itemsPriceTypeStr = 'ضمان'
              } else if (parseInt(this.itemsPriceType) === 5) {
                price = this.items[y].warranty_price
                itemsPriceTypeStr = 'هدية'
              } else {
                price = 0
                itemsPriceTypeStr = 'عرض'
              }
              this.receiptItems[this.receiptItems.length] = {}
              this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
              this.receiptItems[this.receiptItems.length - 1].label = this.items[y].item
              this.receiptItems[this.receiptItems.length - 1].rec_id = this.items[y].item_id
              this.receiptItems[this.receiptItems.length - 1].type = 0
              this.receiptItems[this.receiptItems.length - 1].price = price
              this.receiptItems[this.receiptItems.length - 1].priceType = itemsPriceTypeStr
              this.receiptItems[this.receiptItems.length - 1].priceTypeID = this.itemsPriceType
              totalPrice = Number(totalPrice) + Number(price)
            }
          }
        }
      }
      // =================================================
      for (let i = 0; i < this.OfferRecords.length; i++) {
        this.receiptItems[this.receiptItems.length] = {}
        this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
        this.receiptItems[this.receiptItems.length - 1].label = this.OfferRecords[i].item
        this.receiptItems[this.receiptItems.length - 1].rec_id = this.OfferRecords[i].rec_id
        this.receiptItems[this.receiptItems.length - 1].type = 0
        this.receiptItems[this.receiptItems.length - 1].price = this.OfferRecords[i].price
        this.receiptItems[this.receiptItems.length - 1].priceType = this.OfferRecords[i].price_type_str
        this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
        totalPrice = Number(totalPrice) + Number(this.OfferRecords[i].price)
      }
      // =================================================
      /*
      for (let i = 0; i < this.InstallmentRecords.length; i++) {
        if (this.InstallmentRecords[i].action) {
          const str1 = 'سداد قسط '
          const str2 = ' عن شهر '
          this.receiptItems[this.receiptItems.length] = {}
          this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
          this.receiptItems[this.receiptItems.length - 1].label = str1 + this.InstallmentRecords[i].id.toString() + str2 + this.InstallmentRecords[i].due_date.substring(5, 7)
          this.receiptItems[this.receiptItems.length - 1].rec_id = 0
          this.receiptItems[this.receiptItems.length - 1].type = 9
          this.receiptItems[this.receiptItems.length - 1].price = this.InstallmentRecords[i].reset
        }
      }
      */
      // =================================================
      for (let i = 0; i < this.maintenancRecords.length; i++) {
        if (this.maintenancRecords[i].action) {
          const str = 'تغيير '
          this.receiptItems[this.receiptItems.length] = {}
          this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
          this.receiptItems[this.receiptItems.length - 1].label = str + this.maintenancRecords[i].item
          this.receiptItems[this.receiptItems.length - 1].rec_id = this.maintenancRecords[i].item_id
          this.receiptItems[this.receiptItems.length - 1].type = 10
          this.receiptItems[this.receiptItems.length - 1].price = 0
          this.receiptItems[this.receiptItems.length - 1].priceType = ''
          this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
        }
      }
      // -----------------------------------------------------------
      this.receiptItems[this.receiptItems.length] = {}
      this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
      this.receiptItems[this.receiptItems.length - 1].label = 'إجمالى المديونية'
      this.receiptItems[this.receiptItems.length - 1].rec_id = 0
      this.receiptItems[this.receiptItems.length - 1].type = 4
      this.receiptItems[this.receiptItems.length - 1].price = totalPrice
      this.receiptItems[this.receiptItems.length - 1].priceType = ''
      this.receiptItems[this.receiptItems.length - 1].priceTypeID = 0
      // -----------------------------------------------------------
      /*
      this.receiptItems[this.receiptItems.length] = {}
      this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
      this.receiptItems[this.receiptItems.length - 1].label = 'المدفوع'
      this.receiptItems[this.receiptItems.length - 1].rec_id = 0
      this.receiptItems[this.receiptItems.length - 1].type = 5
      this.receiptItems[this.receiptItems.length - 1].price = parseInt(this.record.paid || 0)
      // -----------------------------------------------------------
      this.receiptItems[this.receiptItems.length] = {}
      this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
      this.receiptItems[this.receiptItems.length - 1].label = 'الباقى'
      this.receiptItems[this.receiptItems.length - 1].rec_id = 0
      this.receiptItems[this.receiptItems.length - 1].type = 6
      this.receiptItems[this.receiptItems.length - 1].price = parseInt(totalPrice || 0) - parseInt(this.record.paid || 0)
      */
      // =================================================
      for (let i = 0; i < this.InstallmentRecords.length; i++) {
        if (this.InstallmentRecords[i].action) {
          this.receiptItems[this.receiptItems.length] = {}
          this.receiptItems[this.receiptItems.length - 1].id = this.receiptItems.length
          this.receiptItems[this.receiptItems.length - 1].label = 'قسط ' + this.InstallmentRecords[i].due_date
          this.receiptItems[this.receiptItems.length - 1].rec_id = this.InstallmentRecords[i].rec_id
          this.receiptItems[this.receiptItems.length - 1].type = 11
          this.receiptItems[this.receiptItems.length - 1].price = this.InstallmentRecords[i].reset
          this.receiptItems[this.receiptItems.length - 1].priceType = ''
          this.receiptItems[this.receiptItems.length - 1].priceTypeID = ''
        }
      }
      // ------------------------------
      let instID = null
      let instMonth = null
      let MyDate = null
      var Myday = null
      var paid = 0
      this.InstallmentRecords.forEach(function (rec) {
        if (rec.action) {
          MyDate = rec.due_date
          paid = paid + rec.reset
          if (instID !== null) {
            instID = instID.concat(' + ', rec.id)
            instMonth = instMonth.concat(' + ', rec.due_date.substring(5, 7))
          } else {
            instID = rec.id.toString()
            instMonth = rec.due_date.substring(5, 7)
          }
        }
      })
      if (!isFromPaid) {
        this.record.paid = parseInt(paid) + parseInt(this.record.maintenance_balance)
      }

      const d = new Date()
      let month = d.getMonth() + 1
      let year = d.getFullYear()
      if (MyDate !== null) {
        Myday = MyDate.substring(10, 8)
        this.receiptDate = year + '-' + month + '-' + Myday
      } else {
        this.receiptDate = null
      }
      if (instID !== null) {
        this.record.caption = 'سداد قسط رقم )' + instID + '(' + ' عن شهر: ' + instMonth
      } else {
        this.record.caption = ''
      }
      // -----------------------------
      this.record.required = totalPrice
      this.record.rest = parseInt(totalPrice || 0) - parseInt(this.record.paid || 0)
      if (this.record.paid > 0) {
        this.record.amount_str = '-مبلغ وقدره ' + this.record.paid + ' جنيه ' + tafqeet(this.record.paid) + ' جنيهاً فقط لا غير-'
      } else {
        this.record.amount_str = 'لا شيئ'
      }
      // --------------------------------------
      if (this.record.rest > 0) {
        this.record.rest_str = 'والمبلغ المتبقى ' + this.record.rest + 'ج فقط ' + tafqeet(this.record.rest) + ' جنيهاً لا غير'
      } else {
        this.record.rest_str = 'المبلغ المتبقى: صفر (لا توجد اقساط مستحقة من ثمن الفلتر)'
      }
    },
    // ========================================================
    changeMaintenanAction (id) {
      let i = this.maintenancRecords.map(record => record.id).indexOf(id)
      if (i > -1) {
        if (this.maintenancRecords[i].change_date === null) {
          this.maintenancRecords[i].action = !this.maintenancRecords[i].action
        }
      }
      this.fillReceiptItems()
    },
    // ========================================================
    changeAction (id) {
      let i = this.InstallmentRecords.map(record => record.id).indexOf(id)
      if (i > -1) {
        if (this.InstallmentRecords[i].reset > 0) {
          this.InstallmentRecords[i].action = !this.InstallmentRecords[i].action
        }
      }
      this.fillReceiptItems()
    },
    // ========================================================
    mirrorNotes () {
      this.record.notes = this.record.callNotes
    },
    // ========================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    getData (id, fromDate, toDate, type) {
      this.isContractOffersLoading = true
      this.noRecords = false
      axios.post(this.$apiURL + 'get-rec-for-create-receipt', {
        token: localStorage.getItem('token'),
        id: id,
        type: type,
        offer_id: this.offer_id,
        branch_id: this.$store.state.customerData.branche_id,
        contract_offer_id: this.contract_offer_id,
        date_from: fromDate,
        isInLimit: this.isInLimit,
        date_to: toDate
      })
        .then(res => {
          if (res.data === 'No Records') {
            this.noRecords = true
          } else {
            this.isContractOffersLoading = false
            if (parseInt(type) === 1) {
              this.record = res.data.Data
              this.record.delay = 0
              this.InstallmentRecords = res.data.Installment
              this.maintenancRecords = res.data.Maintenances
              this.record.paid = parseInt(this.record.balance) + parseInt(this.record.maintenance_balance)
              this.record.required = parseInt(this.record.balance) + parseInt(this.record.maintenance_balance)
              this.changeAction(0)
            } else {
              this.record = res.data
            }
            this.fillReceiptItems()
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isContractOffersLoading = false
        })
    },
    saveData () {
      this.validationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'create-cash-receipt01', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        contract_id: this.record.contract_id,
        contract_offer_id: this.record.contract_offer_id,
        amount: this.record.paid,
        amount_str: this.record.amount_str,
        maintenance_expenses: this.record.maintenance_expenses,
        receiptItems: this.receiptItems,
        caption: this.record.caption,
        date: this.receiptDate,
        delay: this.record.delay,
        rest: this.record.rest,
        rest_str: this.record.rest_str,
        type_id: this.type,
        maintenance_required: this.record.maintenance_required,
        notes: this.record.notes,
        call_status_id: this.record.call_status_id,
        call_action_id: this.record.call_action_id,
        call_type_id: this.record.call_type_id,
        callNotes: this.record.callNotes,
        call_delay: this.record.call_delay,
        date_from: this.dateFrom,
        date_to: this.dateTo
      })
        .then(res => {
          this.callMethod(this.offer_id)
          this.isLoadingSave = false
          this.OfferRecords = res.data.OfferRecords
          this.record.id = res.data.RecId
          this.errorShow = false
          this.success = 'تم إصدار الايصال رقم #' + res.data + '# بنجاح'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CreateDailyReceipts01.vue